import React from 'react';

export function Citations() {

    return <div className="container py-4">
        <div className="container lead mb-4" style={{minHeight: '50rem'}}>
            <p>
                Thanks for using Spatial Power! If you use Spatial Power in any publication please cite the Spatial Power manuscript and any relevant module publications:
        </p>

            <p>Buller ID, Brown DW, Myers TA, Jones RR, Machiela MJ. <a className='font-weight-bold' href='https://ij-healthgeographics.biomedcentral.com/articles/10.1186/s12942-021-00267-z#article-info' target='_blank'>sparrpowR: a flexible R package to estimate statistical power to identify spatial clustering of two groups and its application.</a> Int J Health Geogr 20, 13 (2021).</p>
        </div>
    </div>
}